import { forkJoin , Observable, throwError} from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SelectItem } from 'primeng/api';
import { Credenciales } from '../../../core/entities/credenciales.model';
import { Parameters } from '../../../core/entities/parameters.model';
import { Wsdefs } from '../../../core/entities/wsdefs.model';
import { Setvalues } from '../../../core/entities/setvalues.model';
import { Typefinders } from '../../../core/entities/typefinders.model';
import { Typeruns } from '../../../core/entities/typeruns.model';
import { Xmldefs } from '../../../core/entities/xmldefs.model';
import { Fieldtypes } from '../../../core/entities/fieldtypes.model';
import { Dbattrs } from '../../../core/entities/dbattrs.model';
import { Dbmodels } from '../../../core/entities/dbmodels.model';
import { Dbindices } from '../../../core/entities/dbindices.model';
import { Applicationdefs } from '../../../core/entities/applicationdefs.model';
import { Cas } from '../../../core/entities/cas.model';
import { Fieldlinks } from '../../../core/entities/fieldlinks.model';
import { Xmlfields } from '../../../core/entities/xmlfields.model';
import { Permissions } from '../../../core/entities/permissions.model';
import { Rols } from '../../../core/entities/rols.model';
import { Texts } from 'src/app/core/entities/texts.model';
import { Notices } from 'src/app/core/entities/notices.model';
import { Operations } from '../../../core/entities/operations.model';
import { Dbindexflds } from '../../../core/entities/dbindexflds.model';
import { Statistics } from 'src/app/core/entities/statistics.model';
import { PersonsByIdNumCtrlDig } from 'src/app/core/entities/personsByIdNumCtrlDig.model';
import { Users } from 'src/app/core/entities/users.model';
import { Comments } from 'src/app/core/entities/comments.model';
import { CommentsUsuario } from 'src/app/core/entities/commentsUsuario.model';
import { RolsExternal } from 'src/app/core/entities/rolsexternal.model';
import { ParametersService } from '../../../core/repositories/parameters.service';
import { WsdefsService } from '../../../core/repositories/wsdefs.service';
import { SetvaluesService } from '../../../core/repositories/setvalues.service';
import { TypefindersService } from '../../../core/repositories/typefinders.service';
import { TyperunsService } from '../../../core/repositories/typeruns.service';
import { XmldefsService } from '../../../core/repositories/xmldefs.service';
import { FieldtypesService } from '../../../core/repositories/fieldtypes.service';
import { DbattrsService } from '../../../core/repositories/dbattrs.service';
import { DbmodelsService } from '../../../core/repositories/dbmodels.service';
import { DbindicesService } from '../../../core/repositories/dbindices.service';
import { ApplicationdefsService } from '../../../core/repositories/applicationdefs.service';
import { CasService } from '../../../core/repositories/cas.service';
import { FieldlinksService } from '../../../core/repositories/fieldlinks.service';
import { XmlfieldsService } from '../../../core/repositories/xmlfields.service';
import { PermissionsService } from '../../../core/repositories/permissions.service';
import { RolsService } from '../../../core/repositories/rols.service';
import { TextsService } from '../../../core/repositories/texts.service';
import { NoticesService } from '../../../core/repositories/notices.service';
import { OperationsService } from '../../../core/repositories/operations.service';
import { DbindexfldsService } from '../../../core/repositories/dbindexflds.service';
import { UsersService } from '../../../core/repositories/users.service';
import { CommentsService } from 'src/app/core/repositories/comments.service';
import { RepositoryService } from 'src/app/core/repositories/repository.service';
import { RolsExternalService } from 'src/app/core/repositories/rolsexternal.service';
import { DialogsBuscadorComponent } from '../../../shared/components/dialogs/dialogs-buscador/dialogs-buscador.component';
import { DialogsSendMailsComponent } from 'src/app/shared/components/dialogs/dialogs-send-mails/dialogs-send-mails.component';
import { PETICIONES, STORAGE } from 'src/app/core/utils/constants';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { MenubarModule } from 'primeng/menubar';
import * as _ from 'lodash';

@Injectable()
export class InternalHomeService {

  items: MenuItem[] = [];
  itemBar: MenubarModule[] = [];

  user: Credenciales = new Credenciales();

  parametrosRemove: Parameters = new Parameters();
  parametros: Parameters[] = new Array<Parameters>();
  arrayParameters: Parameters[] = new Array<Parameters>();
  arrayParametersFiltro: Parameters[] = new Array<Parameters>();

  wsdefsRemove: Wsdefs = new Wsdefs();
  wsdefs: Wsdefs[] = new Array<Wsdefs>();
  arrayWsdefs: Wsdefs[] = new Array<Wsdefs>();
  arrayWsdefsFiltro: Wsdefs[] = new Array<Wsdefs>();

  setvaluesRemove: Setvalues = new Setvalues();
  setvalues: Setvalues[] = new Array<Setvalues>();
  arraySetvalues: Setvalues[] = new Array<Setvalues>();
  arraySetvaluesFiltro: Setvalues[] = new Array<Setvalues>();

  typefindersRemove: Typefinders = new Typefinders();
  typefinders: Typefinders[] = new Array<Typefinders>();
  arrayTypefinders: Typefinders[] = new Array<Typefinders>();
  arrayTypefindersFiltro: Typefinders[] = new Array<Typefinders>();

  typerunsRemove: Typeruns = new Typeruns();
  typeruns: Typeruns[] = new Array<Typeruns>();
  arrayTyperuns: Typeruns[] = new Array<Typeruns>();
  arrayTyperunsFiltro: Typeruns[] = new Array<Typeruns>();

  xmldefsRemove: Xmldefs = new Xmldefs();
  xmldefs: Xmldefs[] = new Array<Xmldefs>();
  arrayXmldefs: Xmldefs[] = new Array<Xmldefs>();
  arrayXmldefsFiltro: Xmldefs[] = new Array<Xmldefs>();

  fieldtypesRemove: Fieldtypes = new Fieldtypes();
  fieldtypes: Fieldtypes[] = new Array<Fieldtypes>();
  arrayFieldtypes: Fieldtypes[] = new Array<Fieldtypes>();
  arrayFieldtypesFiltro: Fieldtypes[] = new Array<Fieldtypes>();

  dbattrs: Dbattrs = new Dbattrs();
  viewDbattrs: Dbattrs = new Dbattrs();
  arrayDbattrsFiltro: Dbattrs[] = new Array<Dbattrs>();
  dbmodels: Dbmodels = new Dbmodels();
  viewDbmodels: Dbmodels = new Dbmodels();
  arrayDbmodelsFiltro: Dbmodels[] = new Array<Dbmodels>();
  dbindices: Dbindices = new Dbindices();
  arrayDbindicesFiltro: Dbindices[] = new Array<Dbindices>();

  applicationdefsRemove: Applicationdefs = new Applicationdefs();
  applicationdefs: Applicationdefs[] = new Array<Applicationdefs>();
  arrayApplicationdefs: Applicationdefs[] = new Array<Applicationdefs>();
  arrayApplicationdefsFiltro: Applicationdefs[] = new Array<Applicationdefs>();

  casRemove: Cas = new Cas();
  cas: Cas[] = new Array<Cas>();
  arrayCas: Cas[] = new Array<Cas>();
  arrayCasFiltro: Cas[] = new Array<Cas>();

  fieldlinksRemove: Fieldlinks = new Fieldlinks();
  fieldlinks: Fieldlinks[] = new Array<Fieldlinks>();
  arrayFieldlinks: Fieldlinks[] = new Array<Fieldlinks>();
  arrayFieldlinksFiltro: Fieldlinks[] = new Array<Fieldlinks>();

  textsRemove: Texts = new Texts();
  texts: Texts[] = new Array<Texts>();
  arrayTexts: Texts[] = new Array<Texts>();
  arrayTextsFiltro: Texts[] = new Array<Texts>();

  noticesRemove: Notices = new Notices();
  notices: Notices[] = new Array<Notices>();
  arrayNotices: Notices[] = new Array<Notices>();
  arrayNoticesFiltro: Notices[] = new Array<Notices>();

  xmlfieldsId: Xmlfields = new Xmlfields();
  xmlfieldsRemove: Xmlfields = new Xmlfields();
  xmlfields: Xmlfields[] = new Array<Xmlfields>();
  permissions: Permissions[] = new Array<Permissions>();
  rols: Rols[] = new Array<Rols>();
  operations: Operations[] = new Array<Operations>();
  dbindexfldsRemove: Dbindexflds = new Dbindexflds();
  dbindexflds: Dbindexflds[] = new Array<Dbindexflds>();

  arrayDbmodels: Dbmodels[] = new Array<Dbmodels>();
  arrayDbmodelsAux: Dbmodels[] = new Array<Dbmodels>();
  arrayDbattrs: Dbattrs[] = new Array<Dbattrs>();
  arrayDbattrsAux: Dbattrs[] = new Array<Dbattrs>();
  arrayDbindices: Dbindices[] = new Array<Dbindices>();
  arrayDbindicesAux: Dbindices[] = new Array<Dbindices>();

  arrayDbModelsEnganche: Dbmodels[] = new Array<Dbmodels>();
  arrayDbIndicesEnganche: Dbindices[] = new Array<Dbindices>();

  allusers: Users[] = new Array<Users>();
  users: Users = new Users();
  usuario: Users = new Users();
  optionsUser: SelectItem[] = [];
  optionsUserBase: SelectItem[] = [];

  comment: Comments = new Comments();
  conversacion: Comments[] = new Array<Comments>();
  username: CommentsUsuario[] = new Array<CommentsUsuario>();
  usernamefiltro: CommentsUsuario[] = new Array<CommentsUsuario>();
  personsByIdNumCtrlDig: PersonsByIdNumCtrlDig[] = new Array<PersonsByIdNumCtrlDig>();

  rolExternalRemove: RolsExternal = new RolsExternal();
  rolExternal: RolsExternal[] = new Array<RolsExternal>();
  arrayRolExternal: RolsExternal[] = new Array<RolsExternal>();
  arrayRolExternalFiltro: RolsExternal[] = new Array<RolsExternal>();

  rolInternalRemove: Rols = new Rols();
  rolInternal: Rols[] = new Array<Rols>();
  arrayRolInternal: Rols[] = new Array<Rols>();
  arrayRolInternalFiltro: Rols[] = new Array<Rols>();

  chivato: boolean = true;
  rolesLDAP: String[] = new Array<String>();

  constructor(private paramService: ParametersService,
              private wsdefsService: WsdefsService,
              private setvaluesService: SetvaluesService,
              private typefindersService: TypefindersService,
              private typerunsService: TyperunsService,
              private xmldefsService: XmldefsService,
              private fieldtypesService: FieldtypesService,
              private dbattrsService: DbattrsService,
              private dbmodelsService: DbmodelsService,
              private dbindicesService: DbindicesService,
              private translateService: TranslateService,
              private applicationdefsService: ApplicationdefsService,
              private casService: CasService,
              private fieldlinksService: FieldlinksService,
              private xmlfieldsService: XmlfieldsService,
              private permissionsService: PermissionsService,
              private rolsService: RolsService,
              private textsService: TextsService,
              private noticesService: NoticesService,
              private operationsService: OperationsService,
              private dbindexfldsService: DbindexfldsService,
              private usersService: UsersService,
              private commentsService: CommentsService,
              private rolsExternalService: RolsExternalService,
              private repositoryService: RepositoryService,
              private dialog: MatDialog) { }

  /***************************************************************************/
  /***                    SERVICIOS APPLICATIONDEFS                        ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla applicationdefs */
  public allApplicationdefs(): Observable<any> {
    return this.applicationdefsService.findAll().pipe(map((data: any[]) => {
      data = _.orderBy(data, 'code');
      this.arrayApplicationdefs = data;
      this.arrayApplicationdefsFiltro = data
      this.applicationdefs = data;
      return this.applicationdefs;
    }),catchError((error: any) => {
      console.log(error);
      return throwError(error);
    }));
  }

  /**Llamada al repositorio para eliminar un applicationdef */
  public removeApplicationdefs(applicationdefs?: Applicationdefs): Observable<any> {
    if (!applicationdefs) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.applicationdefsService.deleteApplicationdef(applicationdefs).pipe(map(data => {
      this.applicationdefsRemove = data as Applicationdefs;
      return this.applicationdefsRemove;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Filtro para todos las columnas de la tabla */
  public filterGlobalAplicationdefs(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalApplicationdefs = new Array<Applicationdefs>();
    originalApplicationdefs  = _.cloneDeep(this.arrayApplicationdefsFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalApplicationdefs.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalApplicationdefs[i].code).toLocaleLowerCase());
            break;
          }
          case 2:{
            registro = _.deburr(_.trim(originalApplicationdefs[i].description).toLocaleLowerCase());
            break;
          }
          case 3: {
            registro = _.deburr(_.trim(originalApplicationdefs[i].layout).toLocaleLowerCase());
            break;
          }
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalApplicationdefs[i]));
        }
      }
      this.arrayApplicationdefs = items;
    } else {
      this.arrayApplicationdefs = originalApplicationdefs;
    }

  }

  /***************************************************************************/
  /***                           SERVICIOS CAS                             ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla cas */
  public allCas(): Observable<any> {
    return this.casService.findAll().pipe(map((data: any[]) => {
      data = _.orderBy(data, 'code');
      this.arrayCas = data;
      this.arrayCasFiltro = data;
      //this.cas = data[0] ?? new Cas();
      this.cas = data;
      return this.cas;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un ca */
  public removeCas(cas?: Cas): Observable<any> {
    if (!cas) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.casService.deleteCa(cas).pipe(map(data => {
      this.casRemove = data as Cas;
      return this.casRemove;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Filtro para todos las columnas de la tabla */
  public filterGlobalCas(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalCas = new Array<Cas>();
    originalCas  = _.cloneDeep(this.arrayCasFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalCas.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalCas[i].code).toLocaleLowerCase());
            break;
          }
          case 2:{
            registro = _.deburr(_.trim(originalCas[i].cnIssuer).toLocaleLowerCase());
            break;
          }
          case 3: {
            registro = _.deburr(_.trim(originalCas[i].cn).toLocaleLowerCase());
            break;
          }
          case 4: {
            registro = _.deburr(_.trim(originalCas[i].sn).toLocaleLowerCase());
            break;
          }
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalCas[i]));
        }
      }
      this.arrayCas = items;
    } else {
      this.arrayCas = originalCas;
    }

  }

  /***************************************************************************/
  /***                       SERVICIOS PARAMETROS                          ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla parametros */
  public allParametros(): Observable<any> {
    return this.paramService.findAll().pipe(map((data: any[]) => {
      data = _.orderBy(data, 'code');
      this.arrayParameters = data;
      this.arrayParametersFiltro = data;
      this.parametros = data;
      return this.parametros;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un parametro */
  public removeParametros(parametro?: Parameters): Observable<any> {
    if (!parametro) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.paramService.deleteParameter(parametro).pipe(map(data => {
      this.parametrosRemove = data as Parameters;
      return this.parametrosRemove;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Filtro para todos las columnas de la tabla */
  public filterGlobalParameters(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalParams = new Array<Parameters>();
    originalParams  = _.cloneDeep(this.arrayParametersFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalParams.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalParams[i].code).toLocaleLowerCase());
            break;
          }
          case 2:{
            registro = _.deburr(_.trim(originalParams[i].desc).toLocaleLowerCase());
            break;
          }
          case 3: {
            registro = _.deburr(_.trim(originalParams[i].value).toLocaleLowerCase());
            break;
          }
          case 4: {
            registro = _.deburr(_.trim(originalParams[i].typevalue.toString()).toLocaleLowerCase());
            break;
          }
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalParams[i]));
        }
      }
      this.arrayParameters = items;
    } else {
      this.arrayParameters = originalParams;
    }

  }

  /***************************************************************************/
  /***                       SERVICIOS ROLES EXTERNOS                          ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla rol external */
  public allRolsExternal(): Observable<any> {
    return this.rolsExternalService.findAll().pipe(map((data: any[]) => {
      data = _.orderBy(data, 'id');
      this.arrayRolExternal = data;
      this.arrayRolExternalFiltro = data;
      this.rolExternal = data;
      return this.rolExternal;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un rol external */
  public removeRolsExternal(rolExternal?: RolsExternal): Observable<any> {
    if (!rolExternal) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.rolsExternalService.deleteRolsExternal(rolExternal).pipe(map(data => {
      this.rolExternalRemove = data as RolsExternal;
      return this.rolExternalRemove;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Filtro para todos las columnas de la tabla */
  public filterGlobalRolsExternal(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalRolsExternal = new Array<RolsExternal>();
    originalRolsExternal  = _.cloneDeep(this.arrayRolExternalFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalRolsExternal.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalRolsExternal[i].id.toString()).toLocaleLowerCase());
            break;
          }
          case 2:{
            registro = _.deburr(_.trim(originalRolsExternal[i].code).toLocaleLowerCase());
            break;
          }
          case 3: {
            registro = _.deburr(_.trim(originalRolsExternal[i].descripcion).toLocaleLowerCase());
            break;
          }
          case 4: {
            let valor: string = "";
            originalRolsExternal[i].enable == 0 ? valor = 'NO' : valor = "SI";
            registro = _.deburr(_.trim(valor).toLocaleLowerCase());
            break;
          }
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalRolsExternal[i]));
        }
      }
      this.arrayRolExternal = items;
    } else {
      this.arrayRolExternal = originalRolsExternal;
    }

  }


  /***************************************************************************/
  /***                           SERVICIOS WSDEFS                          ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla wsdefs */
  public allWsdefs(): Observable<any> {
    return this.wsdefsService.findAll().pipe(map((data: any[]) => {
      data = _.orderBy(data, 'code');
      this.arrayWsdefs = data;
      this.arrayWsdefsFiltro = data;
      this.wsdefs = data;
      return this.wsdefs;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un parametro */
  public removeWsdefs(wsdefs?: Wsdefs): Observable<any> {
    if (!wsdefs) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.wsdefsService.deleteWsdef(wsdefs).pipe(map(data => {
      this.wsdefsRemove = data as Wsdefs;
      return this.wsdefsRemove;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Filtro para todos las columnas de la tabla */
  public filterGlobalWsdefs(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalWsdefs = new Array<Wsdefs>();
    originalWsdefs  = _.cloneDeep(this.arrayWsdefsFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalWsdefs.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalWsdefs[i].code).toLocaleLowerCase());
            break;
          }
          case 2:{
            registro = _.deburr(_.trim(originalWsdefs[i].online.toString()).toLocaleLowerCase());
            break;
          }
          case 3: {
            registro = _.deburr(_.trim(originalWsdefs[i].typerun.code).toLocaleLowerCase());
            break;
          }
          case 4: {
            registro = _.deburr(_.trim(originalWsdefs[i].desc).toLocaleLowerCase());
            break;
          }
          case 5: {
            registro = _.deburr(_.trim(originalWsdefs[i].xmldef.code).toLocaleLowerCase());
            break;
          }
          case 6: {
            registro = _.deburr(_.trim(originalWsdefs[i].setvalue.code).toLocaleLowerCase());
            break;
          }
          case 7: {
            registro = _.deburr(_.trim(originalWsdefs[i].typefinder.code).toLocaleLowerCase());
            break;
          }
          case 8: {
            registro = _.deburr(_.trim(originalWsdefs[i].enable.toString()).toLocaleLowerCase());
            break;
          }
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalWsdefs[i]));
        }
      }
      this.arrayWsdefs = items;
    } else {
      this.arrayWsdefs = originalWsdefs;
    }
  }

  /***************************************************************************/
  /***                           SERVICIOS SETVALUES                       ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla setvalues */
  public allSetvalues(): Observable<any> {
    return this.setvaluesService.findAll().pipe(map((data: any[]) => {
      data = _.orderBy(data, 'code');
      this.arraySetvalues = data;
      this.arraySetvaluesFiltro = data;
      this.setvalues = data;
      return this.setvalues;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un parametro */
  public removeSetvalues(setvalues?: Setvalues): Observable<any> {
    if (!setvalues) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.setvaluesService.deleteSetvalue(setvalues).pipe(map(data => {
      this.setvaluesRemove = data as Setvalues;
      return this.setvaluesRemove;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Filtro para todos las columnas de la tabla */
  public filterGlobalSetvalues(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalSetvalues = new Array<Setvalues>();
    originalSetvalues  = _.cloneDeep(this.arraySetvaluesFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalSetvalues.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalSetvalues[i].code).toLocaleLowerCase());
            break;
          }
          case 2:{
            registro = _.deburr(_.trim(originalSetvalues[i].descrip).toLocaleLowerCase());
            break;
          }
          case 3: {
            registro = _.deburr(_.trim(originalSetvalues[i].numorder.toString()).toLocaleLowerCase());
            break;
          }
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalSetvalues[i]));
        }
      }
      this.arraySetvalues = items;
    } else {
      this.arraySetvalues = originalSetvalues;
    }

  }

  /***************************************************************************/
  /***                           SERVICIOS TYPEFINDERS                     ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla typefinders */
  public allTypefinders(): Observable<any> {
    return this.typefindersService.findAll().pipe(map((data: any[]) => {
      data = _.orderBy(data, 'code');
      this.arrayTypefinders = data;
      this.arrayTypefindersFiltro = data;
      this.typefinders = data;
      return this.typefinders;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un typefinder */
  public removeTypefinders(typefinders?: Typefinders): Observable<any> {
    if (!typefinders) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.typefindersService.deleteTypefinder(typefinders).pipe(map(data => {
      this.typefindersRemove = data as Typefinders;
      return this.typefindersRemove;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Filtro para todos las columnas de la tabla */
  public filterGlobalTypefinders(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalTypefinders = new Array<Typefinders>();
    originalTypefinders  = _.cloneDeep(this.arrayTypefindersFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalTypefinders.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalTypefinders[i].code).toLocaleLowerCase());
            break;
          }
          case 2:{
            registro = _.deburr(_.trim(originalTypefinders[i].desc).toLocaleLowerCase());
            break;
          }
          case 3: {
            registro = _.deburr(_.trim(originalTypefinders[i].online.toString()).toLocaleLowerCase());
            break;
          }
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalTypefinders[i]));
        }
      }
      this.arrayTypefinders = items;
    } else {
      this.arrayTypefinders = originalTypefinders;
    }

  }

  /***************************************************************************/
  /***                           SERVICIOS TYPERUNS                        ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla typeruns */
  public allTyperuns(): Observable<any> {
    return this.typerunsService.findAll().pipe(map((data: any[]) => {
      data = _.orderBy(data, 'code');
      this.arrayTyperuns = data;
      this.arrayTyperunsFiltro = data;
      this.typeruns = data;
      return this.typeruns;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un typerun */
  public removeTyperuns(typeruns?: Typeruns): Observable<any> {
    if (!typeruns) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.typerunsService.deleteTyperun(typeruns).pipe(map(data => {
      this.typerunsRemove = data as Typeruns;
      return this.typerunsRemove;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Filtro para todos las columnas de la tabla */
  public filterGlobalTyperuns(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalTyperuns = new Array<Typeruns>();
    originalTyperuns  = _.cloneDeep(this.arrayTyperunsFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalTyperuns.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalTyperuns[i].code).toLocaleLowerCase());
            break;
          }
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalTyperuns[i]));
        }
      }
      this.arrayTyperuns = items;
    } else {
      this.arrayTyperuns = originalTyperuns;
    }

  }

  /***************************************************************************/
  /***                           SERVICIOS XMLDEFS                         ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla xmldefs */
  public allXmldefs(): Observable<any> {
    return this.xmldefsService.findAll().pipe(map((data: any[]) => {
      data = _.orderBy(data, 'code');
      this.arrayXmldefs = data;
      this.arrayXmldefsFiltro = data;
      this.xmldefs = data;
      return this.xmldefs;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un xmldef */
  public removeXmldefs(xmldefs?: Xmldefs): Observable<any> {
    if (!xmldefs) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.xmldefsService.deleteXmldef(xmldefs).pipe(map(data => {
      this.xmldefsRemove = data as Xmldefs;
      return this.xmldefsRemove;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Filtro para todos las columnas de la tabla */
  public filterGlobalXmldefs(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalXmldefs = new Array<Xmldefs>();
    originalXmldefs  = _.cloneDeep(this.arrayXmldefsFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalXmldefs.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalXmldefs[i].code).toLocaleLowerCase());
            break;
          }
          case 2:{
            registro = _.deburr(_.trim(originalXmldefs[i].desc).toLocaleLowerCase());
            break;
          }
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalXmldefs[i]));
        }
      }
      this.arrayXmldefs = items;
    } else {
      this.arrayXmldefs = originalXmldefs;
    }

  }

  /***************************************************************************/
  /***                           SERVICIOS FIELDLINKS                      ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla fieldlinks */
  public allFieldlinks(): Observable<any> {
    return this.fieldlinksService.findAll().pipe(map((data: any[]) => {
      data = _.orderBy(data, 'code');
      this.arrayFieldlinks = data;
      this.arrayFieldlinksFiltro = data;
      this.fieldlinks = data;
      return this.fieldlinks;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un fieldlink */
  public removeFieldlinks(fieldlinks?: Fieldlinks): Observable<any> {
    if (!fieldlinks) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.fieldlinksService.deleteFieldlink(fieldlinks).pipe(map(data => {
      this.fieldlinksRemove = data as Fieldlinks;
      return this.fieldlinksRemove;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Filtro para todos las columnas de la tabla */
  public filterGlobalFieldlinks(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalFieldlinks = new Array<Fieldlinks>();
    originalFieldlinks  = _.cloneDeep(this.arrayFieldlinksFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalFieldlinks.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalFieldlinks[i].code).toLocaleLowerCase());
            break;
          }
          case 2:{
            registro = _.deburr(_.trim(originalFieldlinks[i].description).toLocaleLowerCase());
            break;
          }
          case 3: {
            registro = _.deburr(_.trim(originalFieldlinks[i].ymlkey).toLocaleLowerCase());
            break;
          }
          case 4: {
            registro = _.deburr(_.trim(originalFieldlinks[i].url).toLocaleLowerCase());
            break;
          }
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalFieldlinks[i]));
        }
      }
      this.arrayFieldlinks = items;
    } else {
      this.arrayFieldlinks = originalFieldlinks;
    }

  }

  /***************************************************************************/
  /***                           SERVICIOS FIELDTYPES                      ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla fieldtypes */
  public allFieldtypes(): Observable<any> {
    return this.fieldtypesService.findAll().pipe(map((data: any[]) => {
      data = _.orderBy(data, 'code');
      this.arrayFieldtypes = data;
      this.arrayFieldtypesFiltro = data;
      this.fieldtypes = data;
      return this.fieldtypes;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un fieldtype */
  public removeFieldtypes(fieldtypes?: Fieldtypes): Observable<any> {
    if (!fieldtypes) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.fieldtypesService.deleteFieldtype(fieldtypes).pipe(map(data => {
      this.fieldtypesRemove = data as Fieldtypes;
      return this.fieldtypesRemove;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Filtro para todos las columnas de la tabla */
  public filterGlobalFieldtypes(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalFieldtypes = new Array<Fieldtypes>();
    originalFieldtypes  = _.cloneDeep(this.arrayFieldtypesFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalFieldtypes.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalFieldtypes[i].code).toLocaleLowerCase());
            break;
          }
          case 2:{
            registro = _.deburr(_.trim(originalFieldtypes[i].desc).toLocaleLowerCase());
            break;
          }
          case 3:{
            registro = _.deburr(_.trim(originalFieldtypes[i].url).toLocaleLowerCase());
            break;
          }
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalFieldtypes[i]));
        }
      }
      this.arrayFieldtypes = items;
    } else {
      this.arrayFieldtypes = originalFieldtypes;
    }

  }

  /***************************************************************************/
  /***                           SERVICIOS DBATTRS                         ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla dbattrs */
  public allDbattrs(): Observable<any> {
    return forkJoin({
        valor0: this.dbattrsService.findAll(),
        valor1: this.allDbmodels()
    
      }).pipe(map(dataGroup => {

      this.arrayDbattrs = dataGroup.valor0 as Dbattrs[];
      this.arrayDbattrsAux = dataGroup.valor0 as Dbattrs[];
      this.arrayDbmodels = dataGroup.valor1;
      let contador;
      for(let i = 0; i < this.arrayDbattrs.length; i++){
        contador = 0;
        this.arrayDbModelsEnganche =  new Array<Dbmodels>();
        for(let j = 0; j < this.arrayDbmodels.length; j++){
          if(this.arrayDbattrs[i].id === this.arrayDbmodels[j].dbattrId.id){
            contador++;
            this.arrayDbattrs[i].modelo = contador;
            this.arrayDbattrs[i].dbmodels = this.arrayDbModelsEnganche;
            this.arrayDbattrs[i].dbmodels.push(this.arrayDbmodels[j]);
          }
        }
      }

      this.arrayDbattrs = _.orderBy(this.arrayDbattrs, 'code');
      this.arrayDbattrsFiltro = this.arrayDbattrs;
      return this.arrayDbattrs;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un dbattr */
  public removeDbattrs(dbattrs?: Dbattrs): Observable<any> {
    if (!dbattrs) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.dbattrsService.deleteDbattr(dbattrs).pipe(map(data => {
      this.dbattrs = data as Dbattrs;
      return this.dbattrs;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Filtro para todos las columnas de la tabla */
  public filterGlobalDbattrs(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalDbattrs = new Array<Dbattrs>();
    originalDbattrs  = _.cloneDeep(this.arrayDbattrsFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalDbattrs.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalDbattrs[i].code).toLocaleLowerCase());
            break;
          }
          case 2:{
            registro = _.deburr(_.trim(originalDbattrs[i].adapterstr).toLocaleLowerCase());
            break;
          }
          case 3:{
            registro = _.deburr(_.trim(originalDbattrs[i].usernamestr).toLocaleLowerCase());
            break;
          }
          case 4:{
            registro = _.deburr(_.trim(originalDbattrs[i].dbattr1key).toLocaleLowerCase());
            break;
          }
          case 5:{
            registro = _.deburr(_.trim(originalDbattrs[i].dbattr1value).toLocaleLowerCase());
            break;
          }
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalDbattrs[i]));
        }
      }
      this.arrayDbattrs = items;
    } else {
      this.arrayDbattrs = originalDbattrs;
    }

  }

  /***************************************************************************/
  /***                           SERVICIOS DBMODELS                        ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla dbmodels */
  public allDbmodels(): Observable<any> {
    return forkJoin({
        valor0: this.dbmodelsService.findAll(),
        valor1: this.allDbindices()
    }).pipe(map(dataGroup => {

      if((this.arrayDbmodels.length <= 0) && (this.chivato)){
        this.arrayDbmodels = dataGroup.valor0 as Dbmodels[];
        this.arrayDbmodelsAux = dataGroup.valor0 as Dbmodels[];
        this.arrayDbindices = dataGroup.valor1;
        let contador;
        for (let i = 0; i < this.arrayDbmodels.length; i++) {
          contador = 0;
          this.arrayDbIndicesEnganche = new Array<Dbindices>();
          for (let j = 0; j < this.arrayDbindices.length; j++) {
            if (this.arrayDbmodels[i].id === this.arrayDbindices[j].dbmodelId.id) {
              contador++;
              this.arrayDbmodels[i].indice = contador;
              this.arrayDbmodels[i].dbindices = this.arrayDbIndicesEnganche;
              this.arrayDbmodels[i].dbindices.push(this.arrayDbindices[j]);
            }
          }
        }
      }
      this.arrayDbmodels = _.orderBy(this.arrayDbmodels, 'code');
      this.arrayDbmodelsFiltro = this.arrayDbmodels;
      return this.arrayDbmodels;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un dbmodel */
  public removeDbmodels(dbmodels?: Dbmodels): Observable<any> {
    if (!dbmodels) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.dbmodelsService.deleteDbmodel(dbmodels).pipe(map(data => {
      this.dbmodels = data as Dbmodels;
      return this.dbmodels;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Filtro para todos las columnas de la tabla */
  public filterGlobalDbmodels(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalDbmodels = new Array<Dbmodels>();
    originalDbmodels  = _.cloneDeep(this.arrayDbmodelsFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalDbmodels.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalDbmodels[i].code).toLocaleLowerCase());
            break;
          }
          case 2:{
            registro = _.deburr(_.trim(originalDbmodels[i].description).toLocaleLowerCase());
            break;
          }
          case 3:{
            registro = _.deburr(_.trim(originalDbmodels[i].dbattrId.code).toLocaleLowerCase());
            break;
          }
          case 4:{
            registro = _.deburr(_.trim(originalDbmodels[i].xmldefId.code).toLocaleLowerCase());
            break;
          }
          case 5:{
            registro = _.deburr(_.trim(originalDbmodels[i].dbobjname).toLocaleLowerCase());
            break;
          }
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalDbmodels[i]));
        }
      }
      this.arrayDbmodels = items;
    } else {
      this.arrayDbmodels = originalDbmodels;
    }

  }

  /***************************************************************************/
  /***                           SERVICIOS DBINDICES                       ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla dbindices */
  public allDbindices(): Observable<any> {
    return this.dbindicesService.findAll().pipe(map((data: any[]) => {
      console.log(this.arrayDbindices);
      console.log(data);
      if(this.arrayDbindices.length <= 0){
        data = _.orderBy(data, 'code');
        this.arrayDbindicesAux = data;
        this.arrayDbindicesFiltro = data;
        this.arrayDbindices = data;
        return this.arrayDbindices;
      }else{
        this.arrayDbindices = _.orderBy(this.arrayDbindices, 'code');
        return this.arrayDbindices;
      }
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un dbindice */
  public removeDbindices(dbindices?: Dbindices): Observable<any> {
    if (!dbindices) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.dbindicesService.deleteDbindice(dbindices).pipe(map(data => {
      this.dbindices = data as Dbindices;
      return this.dbindices;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Filtro para todos las columnas de la tabla */
  public filterGlobalDbindices(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalDbindices = new Array<Dbindices>();
    originalDbindices  = _.cloneDeep(this.arrayDbindicesFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalDbindices.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalDbindices[i].code).toLocaleLowerCase());
            break;
          }
          case 2:{
            registro = _.deburr(_.trim(originalDbindices[i].dbmodelId.code).toLocaleLowerCase());
            break;
          }
          case 3:{
            registro = _.deburr(_.trim(originalDbindices[i].description).toLocaleLowerCase());
            break;
          }
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalDbindices[i]));
        }
      }
      this.arrayDbindices = items;
    } else {
      this.arrayDbindices = originalDbindices;
    }

  }

  /***************************************************************************/
  /***                           SERVICIOS XMLFIELDS                       ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla xmlfields */
  public allXmlfields(): Observable<any> {
    return this.xmlfieldsService.findAll().pipe(map((data: any[]) => {
      data = _.orderBy(data, 'code');
      this.xmlfields = data;
      return this.xmlfields;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un xmlfields */
  public removeXmlfields(xmlfields?: Xmlfields): Observable<any> {
    if (!xmlfields) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.xmlfieldsService.deleteXmlfield(xmlfields).pipe(map(data => {
      this.xmlfieldsRemove = data as Xmlfields;
      return this.xmlfieldsRemove;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio traernos los datos de la tabla xmlfields con el mismo id */
  public getbyIdXmlfields(xmlfields?: number): Observable<any> {
    if (!xmlfields) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.xmlfieldsService.findByXmldefId(xmlfields).pipe(map(data => {
      this.xmlfieldsId = data as Xmlfields;
      return this.xmlfieldsId;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /***************************************************************************/
  /***                         SERVICIOS PERMISSIONS                       ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla permissions */
  public allPermissions(): Observable<any> {
    return this.permissionsService.findAll().pipe(map((data: any[]) => {
      this.permissions = data;
      return this.permissions;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /***************************************************************************/
  /***                         SERVICIOS ROLL INTERNOS                       ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla rols */
  public allRolls(): Observable<any> {
    return this.rolsService.findAll().pipe(map((data: any[]) => {
      this.rols = data;
      return this.rols;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para traernos todos los datos de la tabla rol internal */
  public allRolsInternal(): Observable<any> {
    return this.rolsService.findAll().pipe(map((data: any[]) => {
      data = _.orderBy(data, 'id');
      this.arrayRolInternal = data;
      this.arrayRolInternalFiltro = data;
      this.rolInternal = data;
      return this.rolInternal;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un rol internal */
  public removeRolsInternal(rolInternal?: Rols): Observable<any> {
    if (!rolInternal) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.rolsService.deleteRolsInternal(rolInternal).pipe(map(data => {
      this.rolInternalRemove = data as Rols;
      return this.rolInternalRemove;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Filtro para todos las columnas de la tabla */
  public filterGlobalRolsInternal(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalRolsInternal = new Array<Rols>();
    originalRolsInternal  = _.cloneDeep(this.arrayRolInternalFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalRolsInternal.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalRolsInternal[i].code).toLocaleLowerCase());
            break;
          }
          case 2: {
            registro = _.deburr(_.trim(originalRolsInternal[i].desc).toLocaleLowerCase());
            break;
          }
          case 3: {
            registro = _.deburr(_.trim(originalRolsInternal[i].desc).toLocaleLowerCase());
            break;
          }
          case 4: {
            let valor: string = "";
            originalRolsInternal[i].proveidor == 0 ? valor = 'NO' : valor = "SI";
            registro = _.deburr(_.trim(valor).toLocaleLowerCase());
            break;
          }
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalRolsInternal[i]));
        }
      }
      this.arrayRolInternal = items;
    } else {
      this.arrayRolInternal = originalRolsInternal;
    }

  }

  /***************************************************************************/
  /***                         SERVICIOS TEXTS                       ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla texts */
  public allTexts(): Observable<any> {
    return this.textsService.findAll().pipe(map((data: any[]) => {
      data = _.orderBy(data, 'code');
      this.arrayTexts = data;
      this.arrayTextsFiltro = data;
      this.texts = data;
      return this.texts;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un text */
  public removeTexts(texts?: Texts): Observable<any> {
    if (!texts) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.textsService.deleteText(texts).pipe(map(data => {
      this.textsRemove = data as Texts;
      return this.textsRemove;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Filtro para todos las columnas de la tabla */
  public filterGlobalTexts(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalTexts = new Array<Texts>();
    originalTexts  = _.cloneDeep(this.arrayTextsFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalTexts.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalTexts[i].code).toLocaleLowerCase());
            break;
          }
          case 2:{
            registro = _.deburr(_.trim(originalTexts[i].desc).toLocaleLowerCase());
            break;
          }
          case 3: {
            registro = _.deburr(_.trim(originalTexts[i].valuecat).toLocaleLowerCase());
            break;
          }
          case 4: {
            registro = _.deburr(_.trim(originalTexts[i].valueesp).toLocaleLowerCase());
            break;
          }
          case 5: {
            registro = _.deburr(_.trim(originalTexts[i].enable.toString()).toLocaleLowerCase());
            break;
          }
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalTexts[i]));
        }
      }
      this.arrayTexts = items;
    } else {
      this.arrayTexts = originalTexts;
    }

  }

  /***************************************************************************/
  /***                         SERVICIOS NOTICES                       ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla notices */
  public allNotices(): Observable<any> {
    return this.noticesService.findAll().pipe(map((data: any[]) => {
      data = _.orderBy(data, 'code');
      this.arrayNotices = data;
      this.arrayNoticesFiltro = data;
      this.notices = data;
      return this.notices;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un notice */
  public removeNotices(notices?: Notices): Observable<any> {
    if (!notices) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.noticesService.deleteNotices(notices).pipe(map(data => {
      this.noticesRemove = data as Notices;
      return this.noticesRemove;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Filtro para todos las columnas de la tabla */
  public filterGlobalNotices(text: string, num: number){
    text != null && text != undefined ? text.trim() : "";
    let items = [];
    let originalNotices = new Array<Notices>();
    originalNotices  = _.cloneDeep(this.arrayNoticesFiltro);

    let registro : string = "";

    if (text != "") {
      for (let i = 0; i < originalNotices.length; i++) {
        let match = false;
        let filterTxt = _.deburr(_.trim(text).toLocaleLowerCase());

        switch(num){
          case 1:{
            registro = _.deburr(_.trim(originalNotices[i].code).toLocaleLowerCase());
            break;
          }
          case 2:{
            registro = _.deburr(_.trim(originalNotices[i].title.code).toLocaleLowerCase());
            break;
          }
          case 3: {
            registro = _.deburr(_.trim(originalNotices[i].description.code).toLocaleLowerCase());
            break;
          }
          case 4: {
            registro = _.deburr(_.trim(originalNotices[i].text_button.code).toLocaleLowerCase());
            break;
          }
          case 5: {
            registro = _.deburr(_.trim(originalNotices[i].enable.toString()).toLocaleLowerCase());
            break;
          }
          /*case 6: {
            registro = _.deburr(_.trim(originalNotices[i].enable.toString()).toLocaleLowerCase());
            break;
          }*/
        }

        if (filterTxt != "" && _.includes(registro, filterTxt)) {
          match = true;
        } else {
          continue;
        }

        if (match) {
          items.push(_.cloneDeep(originalNotices[i]));
        }
      }
      this.arrayNotices = items;
    } else {
      this.arrayNotices = originalNotices;
    }

  }

  /***************************************************************************/
  /***                         SERVICIOS OPERATIONS                        ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla operations */
  public allOperations(): Observable<any> {
    return this.operationsService.findAll().pipe(map((data: any[]) => {
      this.operations = data;
      return this.operations;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /***************************************************************************/
  /***                        SERVICIOS DBINDEXFLDS                        ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla dbindexflds */
  public allDbindexflds(): Observable<any> {
    return this.dbindexfldsService.findAll().pipe(map((data: any[]) => {
      data = _.orderBy(data, 'code');
      this.dbindexflds = data;
      return this.dbindexflds;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**Llamada al repositorio para eliminar un dbindexfld */
  public removeDbindexflds(dbindexflds?: Dbindexflds): Observable<any> {
    if (!dbindexflds) {
      return throwError(() => new Error('Applicationdefs es undefined'));
    }
    return this.dbindexfldsService.deleteDbindexfld(dbindexflds).pipe(map(data => {
      this.dbindexfldsRemove = data as Dbindexflds;
      return this.dbindexfldsRemove;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /***************************************************************************/
  /***                        SERVICIOS USUARIOS                        ***/
  /***************************************************************************/

  /**Llamada al repositorio para traernos todos los datos de la tabla users y construir el select */
  public allUsers(): Observable<any> {
    return this.usersService.findAll().pipe(map((data: any[]) => {
      data = _.orderBy(data, 'name');
      this.allusers = data;
      for (let i = 0; i < this.allusers.length; i++) {
        this.optionsUserBase.push({ value: this.allusers[i].id, label: this.allusers[i].name });
      }
      
      this.optionsUser = this.optionsUserBase;
      this.optionsUserBase = [];

      return this.allusers;
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }

  /**
  * @description
  * Se llama al servicio para traernos un usuario por su login (campo login de tabla users)
  */
  public usersByLogin(user: string): Observable<any> {
    return this.usersService.findByLogin(user).pipe(map((data: any) => {
      this.usuario = _.cloneDeep(data);
    }),catchError((error: any) => {
      console.log(error);
      throw error;
    }));
  }


  /***************************************************************************/
  /***                        SERVICIOS COMENTARIOS                        ***/
  /***************************************************************************/
    /**Llamada al repositorio para guardar un comments */
    public postComments(comments?: Comments): Observable<any> {
      if (!comments) {
        return throwError(() => new Error('Applicationdefs es undefined'));
      }
      return this.commentsService.postComments(comments).pipe(map(data => {
        console.log(data);
        return data;
      }),catchError((error: any) => {
        console.log(error);
        throw error;
      }));
    }
    
    /**Llamada al repositorio para guardar sacar los datos de la tercera persona (dboid) */
    public tercerPerson(nif: string): Observable<any>{
      return this.repositoryService.doGet(PETICIONES.personsByIdNumCtrlDig.findAll + "/" + nif).pipe(map(data => {
        this.personsByIdNumCtrlDig = _.cloneDeep(data.personsByIdNumCtrlDig);
        return data;
      }),catchError((error: any) => {
        console.log(error);
        throw error;
      }));
    }

    /**Llamada al repositorio para guardar sacar los datos de la tercera persona (dboid) */
    public mostrarConversacion(user: string, nif: string, usuario: string): Observable<any>{
      return this.commentsService.findByUserNif(user, nif, usuario).pipe(map((data: any) => {
        data = _.orderBy(data, 'createdAt').reverse();
        this.conversacion = _.cloneDeep(data);
        return data;
      }),catchError((error: any) => {
        console.log(error);
        throw error;
      }));
    }

    /**
    * @description
    * Se llama al servicio para traernos una lista de todos los comentarios a los que hemos 
    * enviado a los usuarios.
    */
    public usersByUsername(username: string): Observable<any> {
      return this.commentsService.findByUsername(username).pipe(map(data => {
        this.username = _.cloneDeep(data) as CommentsUsuario [];
        this.usernamefiltro = _.cloneDeep(data) as CommentsUsuario [];
        console.log(this.username);
      }),catchError((error: any) => {
        console.log(error);
        throw error;
      }));
    }

  /***************************************************************************/
  /***                              MOSTRAR MENU                           ***/
  /***************************************************************************/

  /**
  * @description
  * Genera el menu horizontal bajo la cabecera
  */
  public mostrarMenu() {
    let roles = localStorage.getItem(STORAGE.ALLROLS);
    let include: boolean;
    if(roles != null){
      this.rolesLDAP = JSON.parse(roles);
      include = this.rolesLDAP.includes('ROLE_carpeta_fi4admin');
    }
    this.translateService.get(['MENU']).subscribe((res: string[]) => {

      this.items = [
        {
          label: this.translateService.instant('MENU.num_identif'),
          command: e => this.numIdentificacion(e)
        },
        { separator: true },
        {
          label: this.translateService.instant('MENU.mantenimiento'),
          visible : include,
          items: [
            {
              label: this.translateService.instant('MENU.front_end'),
              routerLink: "/internal/home/applicationdefs"
            },
            {
              label: this.translateService.instant('MENU.parametros'),
              routerLink: "/internal/home/parameters"
            },
            {
              label: this.translateService.instant('MENU.ca_definicion'),
              routerLink: "/internal/home/cas"
            },
            {
              label: this.translateService.instant('MENU.roles'),
              items: [
                {
                  label: this.translateService.instant('MENU.rolinternal'),
                  routerLink: "/internal/home/rolinternal"
                },
                {
                  label: this.translateService.instant('MENU.rolexternal'),
                  routerLink: "/internal/home/rolexternal"
                }
              ]
            },
            {
              label: this.translateService.instant('MENU.statistics'),
              items: [
                {
                  label: this.translateService.instant('MENU.statistics_int'),
                  routerLink: "/internal/home/statistics"
                },
                {
                  label: this.translateService.instant('MENU.statistics_ext'),
                  routerLink: "/internal/home/statistisexteranl"
                }
              ]
            },
            {
              label: this.translateService.instant('MENU.text_admin'),
              items: [
                {
                  label: this.translateService.instant('MENU.notices'),
                  routerLink: "/internal/home/notices"
                },
                {
                  label: this.translateService.instant('MENU.textos'),
                  routerLink: "/internal/home/texts"
                }
              ]
            },
            {
              label: this.translateService.instant('MENU.web_services'),
              items: [
                {
                  label: this.translateService.instant('MENU.def_web_services'),
                  routerLink: "/internal/home/wsdefs"
                },
                {
                  label: this.translateService.instant('MENU.categorias_ws'),
                  routerLink: "/internal/home/setvalue_wscategories"
                },
                {
                  label: this.translateService.instant('MENU.typefinders'),
                  routerLink: "/internal/home/typefinders"
                },
                {
                  label: this.translateService.instant('MENU.tipos_ws'),
                  routerLink: "/internal/home/typeruns"
                }
              ]
            },
            {
              label: this.translateService.instant('MENU.xml_atributos'),
              items: [
                {
                  label: this.translateService.instant('MENU.definicion_xml'),
                  routerLink: "/internal/home/xmldefs"
                },
                {
                  label: this.translateService.instant('MENU.tipo_campo'),
                  routerLink: "/internal/home/fieldtypes"
                },
                {
                  label: this.translateService.instant('MENU.links'),
                  routerLink: "/internal/home/fieldlinks"
                }
              ]
            },
            {
              label: this.translateService.instant('MENU.db_objects'),
              items: [
                {
                  label: this.translateService.instant('MENU.db_attrs'),
                  routerLink: "/internal/home/dbattrs"
                },
                {
                  label: this.translateService.instant('MENU.db_models'),
                  routerLink: "/internal/home/dbmodels"
                },
                {
                  label: this.translateService.instant('MENU.db_index'),
                  routerLink: "/internal/home/dbindices",
                  items: [
                    {
                      label: this.translateService.instant('MENU.db_dbindexflds'),
                      routerLink: "/internal/home/dbindices/dbindexflds"
                    }
                  ]
                }
              ]
            },
          ]
        },
        { separator: true },
        {
          label: this.translateService.instant('MENU.emails'),
          command: e => this.sendEmail(e)
        },
        { separator: true }
      ];
    });
  }

  /**
  * @description
  * Abre el cuadro de dialogo para filtrar busqueda por nif y rol 
  */
  public numIdentificacion(e: any) {

    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '80%' : anchodisp = "50%";

    const dialogRef = this.dialog.open(DialogsBuscadorComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { e }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  /**
  * @description
  * Abre el cuadro de dialogo para el envío de un correo interno
  */
   public sendEmail(e: any) {

    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '90%' : anchodisp = "65%";

    const dialogRef = this.dialog.open(DialogsSendMailsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { e }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
